<button [iconButton]="'filled'"
        [status]="status"
        [iconSize]="24"
        [icon]="inWishlist ? 'wishlist-fill' : 'wishlist'"
        (click)="toggle()"
        [attr.aria-label]="inWishlist ? 'Remove from wishlist' : 'Add to wishlist'"
        cy-wishlistaddbutton
        class="inline-flex _wishlist flex-middle flex-justify-center box-shadow-1"></button>